var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOnMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M39.5566406,8.4433594c-1.5517578-1.5507812-3.2607422-2.8369141-5.0800781-3.8222656l-0.953125,1.7578125 c1.6503906,0.8945312,3.2041016,2.0644531,4.6191406,3.4785156c7.796875,7.7978516,7.796875,20.4873047,0,28.2851562 c-7.7978516,7.7988281-20.4873047,7.796875-28.2851562,0c-7.796875-7.7978516-7.796875-20.4873047,0-28.2851562 c1.4150391-1.4140625,2.96875-2.5839844,4.6191406-3.4785156l-0.953125-1.7578125 c-1.8193359,0.9853516-3.5283203,2.2714844-5.0800781,3.8222656c-8.5771484,8.578125-8.5771484,22.5351562,0,31.1132812 C12.7324219,43.8457031,18.3662109,45.9892578,24,45.9892578s11.2675781-2.1445312,15.5566406-6.4326172 C48.1337891,30.9785156,48.1337891,17.0214844,39.5566406,8.4433594z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 0,
    width: 2,
    height: 24
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnMedium);
export default __webpack_public_path__ + "static/media/on--medium.79c88372c71911dad2678cdb58c1d155.svg";
export { ForwardRef as ReactComponent };